import { render, staticRenderFns } from "./SubmissionList.vue?vue&type=template&id=5541a8d0&scoped=true&"
import script from "./SubmissionList.vue?vue&type=script&lang=js&"
export * from "./SubmissionList.vue?vue&type=script&lang=js&"
import style0 from "./SubmissionList.vue?vue&type=style&index=0&id=5541a8d0&prod&lang=scss&scoped=true&"
import style1 from "./SubmissionList.vue?vue&type=style&index=1&id=5541a8d0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5541a8d0",
  null
  
)

export default component.exports